import React, {useEffect,useState,useContext} from "react";
import {useTranslate} from 'react-polyglot';
import CustomMonoriel from "../../services/CustomMonoriel";
import { DialogActions, DialogButton } from '@rmwc/dialog';
import ShowLoadingContext from '../../context/ShowLoadingContext';
import "./editAR.scss"
import AlertDialog from '../general/AlertDialog';
import { Snackbar, TextField} from '@mui/material';
import Appcontext from '../app/AppContext';
import CoaTextField from "../textfield";
import ActionButtons from "../actionsDialog/ActionButtons";
import { SnackbarAction } from "rmwc";

export default function ChangeName(props) {
    const context = useContext(Appcontext);
    const t = useTranslate();
    const [name, setName] = useState(props.data)
    const { setShowLoading } = useContext(ShowLoadingContext)
    const [open, setOpen] = useState({
        title: '',
        subtitle: '',
        isOpen: false
    })

    useEffect(()=> {
    },[])

    async function changeName() {
        try {
            setShowLoading(true)
            await CustomMonoriel.changeMoesName(props.keyData, name)
            .then(rta => {
                setShowLoading(false)
                setOpen({
                    title: t('common.msg.success'),
                    subtitle: t('customLoaderLayout.applyChanges'),
                    isOpen: true
                });
                context.page.refetch();
            });
        } catch (error) {
            throw new Error(error);
        }
        setShowLoading(false); 
    }

    return (
        <>
        <div className={`coa-dialog-form coa-dialog-with-action-buttons`}>
            <CoaTextField
                data={name}
                onChange={setName}
                label={t('experiences.newName')}
            />
            <ActionButtons
                cancelText={t('actions.cancel')}
                acceptText={t('actions.accept')}
                acceptDisabled={name.trim() === '' || name.trim() === props.data}
                onClickCancel={(e) => {e.preventDefault()}}
                onClickAccept={(e) => {
                    e.preventDefault()
                    changeName()
                }}
            ></ActionButtons>
            <Snackbar
                open={open.isOpen}
                message={open.subtitle}
                dismissesOnAction
                action={
                    <SnackbarAction icon={open.icon}/>
                }
            />
        </div>
        </>
    )
}